import type { Beat, Seconds } from '../core/types';

export const BEATS_PER_BAR = 4;
export const DEFAULT_BPM = 124;

export function beatToSeconds(beat: Beat, bpm: number): Seconds {
  return (beat * 60) / bpm;
}

export function beatTime(start: Seconds, beat: Beat, bpm: number): Seconds {
  return start + beatToSeconds(beat, bpm);
}

export function secondsToBeat(seconds: Seconds, bpm: number): Beat {
  return (seconds * bpm) / 60;
}
